/*
 * @Author: yuanyunpeng 15226551376@163.com
 * @Date: 2023-05-19 11:18:26
 * @LastEditors: yuanyunpeng 15226551376@163.com
 * @LastEditTime: 2023-05-25 08:56:29
 * @FilePath: \web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router/router';
import Router from 'vue-router';
import store from './store/index';
import VMS from './lib/vms-web-sdk/vms-web-sdk-1.0.0.esm.min';
import * as globalMethod from '@/utils/params';
import './assets/font/iconfont/iconfont.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/common.less';
import { getToken } from '@/utils/auth';
import axios from 'axios';
import request from '@/utils/request';
import { api } from '@/api/all';
import mynpmchat from 'mynpmchatonline';
import tool  from '@/utils/tool';
import ElTablePlus from 'el-table-plus';
import 'el-table-plus/lib/index.css';
// import Vue from 'vue';
import Directive from './directive/index.js';

import ConfirmBox from './components/ConfirmBox/ConfirmBox'
import MessageBox from './components/MessageBox/MessageBox'

let confirmBox = Vue.extend(ConfirmBox);
let messageBox = Vue.extend(MessageBox);

// 全局注册确认消息对话框组件
let _confirmDialog =  (content, title, options) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  options = Object.assign({
    title: title,
    content: content
  }, options);

  let instance = new confirmBox({
    data: options
  }).$mount();

  document.body.appendChild(instance.$el);

  return instance.confirm();
}

// 全局注册提示消息对话框
let _message = (type, content) => {
  let instance = new messageBox({
    data: {
      type: type,
      content: content
    }
  }).$mount();

  document.body.appendChild(instance.$el);
  return instance.init();
}


Vue.use(tool);
// import '../node_modules/mynpmchatonline/myNpmChat.css';

Vue.use(mynpmchat);

// 全局方法挂载
Vue.prototype.request = request;
Vue.prototype.$_confirmDialog = _confirmDialog;
Vue.prototype.$_message = _message;
Vue.prototype.$axios = axios;

//通用跳转机器人方法
Vue.prototype.$goRobotPage = (issueContent)=>{
  if(issueContent){
    window.open(`${process.env.KE_FU_URL}?propType=1&propInputMsg=${issueContent}`, '_blank')
  }else{
    window.open(`${process.env.KE_FU_URL}?propType=1`, '_blank')
  }
}

//全局变量挂载
Vue.prototype.$api = api;
Vue.prototype.$getToken = getToken;
Object.keys(globalMethod).forEach(key => {
  Vue.prototype[key] = globalMethod[key];
});



Vue.use(ElementUI);
Vue.use(Router);
Vue.config.productionTip = false;
Vue.use(VMS);
Vue.use(ElTablePlus);
Vue.use(Directive)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js